import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {ModalHeader, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { API_URL } from '../../../config';
import right from '../../images/right.png';
import { Multiselect } from "multiselect-react-dropdown";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const UploadRecordingCustomer = () => {
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [recordingType, setRecordingType] = useState('');
  const [distributorList, setDistributorList] = useState([]);
  const [zoomLink, setZoomLink] = useState('');
  const [recordingVideo, setRecordingVideo] = useState('');
  const [recordingName, setRecordingName] = useState('');
  const [isDistributor, setIsDistributor] = useState('');
  const { id } = useParams();
  const [distributorData, setDistributorData] = useState([]);
  const [recordingNameErr, setRecordingNameErr] = useState(false);
  const [isDistributorErr, setIsDistributorErr] = useState(false);
  const [distributorListErr, setDistributorListErr] = useState(false);
  const [recordingTypeErr, setRecordingTypeErr] = useState(false);
  const [zoomLinkErr, setZoomLinkErr] = useState(false);
  const [recordingVideoErr, setRecordingVideoErr] = useState(false);
  const [errMessage, setErrMessage] = useState('')
  const [upcomingRecording, setUpcomingRecording] = useState('');
  const [downloaderModal, setDownloaderModal] = useState(false);
    const DownloaderToggleModal = () => setDownloaderModal(!downloaderModal);
  
  const [selectedDistributor, setSelectedDistributor] = useState([]);
  let simpleArr = []
  const _tempdistributor = []
  const [showItem,setShowItem] = useState(true)
  const navigate = useNavigate()
 const inputRef = React.useRef();
 const [statusFieldErr, setStatusFieldErr] = useState(false);
 const [statusField, setStatusField] = useState('')
 const [show, setShow] = useState(id ? true: false);


 const withoutDulcateDistributorData = [];
const idSet = new Set();

distributorData.forEach(obj => {
  if (!idSet.has(obj.id)) {
    idSet.add(obj.id);
    withoutDulcateDistributorData.push(obj);
  }
});



  const handleRadioChange = (event) =>{
    setIsDistributor(event.target.value)
  }
  
  useEffect(() => {
    getDistributorList()
    if(id){
      getRecordingList();

    }

  }, [])

  const getRecordingList = () => {
    fetch(API_URL + "/get/customer/recording/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setRecordingName(resp.data[0].recording_name)
          setRecordingType(resp.data[0].recording_type)
          setIsDistributor(resp.data[0].distributor_type)
          setStatusField(resp.data[0].status)
          setDistributorList(resp.data[0].customer_list.split(','))
          if(resp.data[0].recording_type==1){
            setZoomLink(resp.data[0].recording)

          }else if(resp.data[0].recording_type==2){
            setRecordingVideo(resp.data[0].recording)
            setUpcomingRecording(resp.data[0].recording)

          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const getDistributorList = () => {
    fetch(API_URL + "/get/all/customer/list",
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          let _temp1 = [];
          resp.data.map((v, i) => {
            if(id){
              distributorList.map((item)=>{
                if(item == v.id ){
                  _temp1.push({name: v.firstname + " " + v.lastname,id:v.id})
                }
              })
            }
            if(v.firstname == null){

            }else{
              _temp.push({name: v.firstname + " " + v.lastname,id:v.id})
            }
          })
          if(_temp.length > 0){
            setDistributorData(_temp);
          }
          if(_temp1.length > 0){
            setDistributorList(_temp1)
          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const createProfile = () => {
    if(isValid()){
    if(recordingType == 1){
  rowData()
  }else if(recordingType == 2){
    formData()
  }
  }else{
    return false;
  }

  }

  const rowData = () =>{
    setDownloaderModal(true)
    let data = {};
    data['recording_name'] = recordingName;
    data['distributor_type'] = isDistributor
     data['customer_list'] = distributorList;
     data['recording_type'] = recordingType;
     data['recording'] = zoomLink 
    fetch(API_URL + "/create/customer/recording/data", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data) 
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-recording-customer') }, 5000);
        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const UpdateRowData = () =>{
    setDownloaderModal(true)
    let data = {};
    data['recording_name'] = recordingName;
    data['distributor_type'] = isDistributor
     data['customer_list'] = distributorList;
     data['recording_type'] = recordingType;
     if(recordingVideo == upcomingRecording && recordingType == 2){
      data['recording'] = recordingVideo;
     }else{
      data['recording'] = zoomLink 
     } 
     data['status'] = statusField; 
    fetch(API_URL + "/update/customer/recording/by/" + id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data) 
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-recording-customer') }, 5000);
        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const formData = () =>{
    setDownloaderModal(true)
    const formData = new FormData();
    formData.append('recording_name', recordingName)
    formData.append('distributor_type', isDistributor)
    formData.append('customer_list', distributorList)
    formData.append('recording_type', recordingType)
    formData.append('form', recordingVideo)
    fetch(API_URL + "/create/customer/recording/data", {
      method: 'POST',
      body: formData 
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-recording-customer') }, 5000);
        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const UpdateFormData = () =>{
    setDownloaderModal(true)
    const formData = new FormData();
    formData.append('recording_name', recordingName)
    formData.append('distributor_type', isDistributor)
    formData.append('customer_list', distributorList)
    formData.append('recording_type', recordingType)
    formData.append('form', recordingVideo)
    formData.append('status', statusField);
    fetch(API_URL + "/update/customer/recording/by/" + id, {
      method: 'PUT',
      body: formData 
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-recording-customer') }, 5000);
        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }


  const updateProfile = () => {
    if(isValid()){
      if(recordingType == 1){
      UpdateRowData();
    }else if(recordingType == 2){
      if(recordingVideo == upcomingRecording){
        UpdateRowData()
      }else{
    UpdateFormData()
      } 
    }
  }else{
    return false
  }

  }
  const handleFileUpload = (event) => {
    const file = event;
  
    if (file) {
      let fileName = '';
      {id && recordingVideo == upcomingRecording ? fileName = file: fileName = file.name}
      // const fileName = file.name;
      const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const isVideo = ['mp4', 'avi', 'mov', 'mkv'].includes(extension);
  
      if (isVideo) {
        return true
      } else {
        return false
      }
    }
  };

  const handleGoBack = () => {
    if(id){
    navigate('/edit-recording-customer');
    }else{
    navigate('/recordings');
    }
  }
  const handleChange = (e)=>{
    // setSelectedDistributor('')
    setDistributorListErr(false)
  
    let _idtemp = []
  
    e.map((item, i )=>{
    
      _idtemp.push(item.id)
   
    })
  
     setDistributorList(_idtemp)
  
  }
  const isValid = () =>{
    if(recordingName=='' && isDistributor == '' && distributorList == '' &&recordingType ==''){
      setRecordingNameErr(true)
      setIsDistributorErr(true)
      setDistributorListErr(true)
      setRecordingTypeErr(true)
      setErrMessage("Field required")
    }else if(recordingName.trim()==''){
      setRecordingNameErr(true)
      setIsDistributorErr(false)
      setDistributorListErr(false)
      setRecordingTypeErr(false)
      setErrMessage("Field required")
    }else if(isDistributor == ''){
      setRecordingNameErr(false)
      setIsDistributorErr(true)
      setDistributorListErr(false)
      setRecordingTypeErr(false)
      setErrMessage("Field required") 
    }
    else if(isDistributor == '6' && distributorList.length==0){
        setRecordingNameErr(false)
        setIsDistributorErr(false)
        setDistributorListErr(true)
        setRecordingTypeErr(false)
        setErrMessage("Field required")
    }else if(recordingType == ''){
      setRecordingNameErr(false)
      setIsDistributorErr(false)
      setDistributorListErr(false)
      setRecordingTypeErr(true)
      setErrMessage("Field required") 
    }else if(id && statusField.length==0 ){
      setRecordingNameErr(false)
      setIsDistributorErr(false)
      setDistributorListErr(false)
      setRecordingTypeErr(false)
      setZoomLinkErr(false)
      setRecordingVideoErr(false)
      setStatusFieldErr(true);
      setErrMessage("Field required")
      return false
    }else if(recordingType=='1' && zoomLink.length==0){
      setRecordingNameErr(false)
      setIsDistributorErr(false)
      setDistributorListErr(false)
      setRecordingTypeErr(false)
      setZoomLinkErr(true)
      setErrMessage("Field required")
    }else if(recordingType=='1' && zoomLink.length!=0){
      if(isZoomLinkValid(zoomLink)){
        return true
      }else{
        setRecordingNameErr(false)
        setIsDistributorErr(false)
        setDistributorListErr(false)
        setRecordingTypeErr(false)
        setZoomLinkErr(true)
        setErrMessage("Enter valid link")
      }
    }else if(recordingType== '2' ){
      if(recordingVideo!=null && !id && recordingVideo !=upcomingRecording && upcomingRecording){
        setRecordingNameErr(false)
        setIsDistributorErr(false)
        setDistributorListErr(false)
        setRecordingTypeErr(false)
        setZoomLinkErr(false)
        setRecordingVideoErr(true)
        setErrMessage("Field required")
      }else if(recordingVideo.length==0){
        setRecordingNameErr(false)
        setIsDistributorErr(false)
        setDistributorListErr(false)
        setRecordingTypeErr(false)
        setZoomLinkErr(false)
        setRecordingVideoErr(true)
        setErrMessage("Field required")
      }
      else{
        if(handleFileUpload(recordingVideo) && id && show ){
          setRecordingVideo(upcomingRecording)
          return true
        }else  if(handleFileUpload(recordingVideo) && !show){
          setRecordingVideo(upcomingRecording)
          setUpcomingRecording('');
          return true
        }else if(recordingVideo == ''&& !show){
          setRecordingNameErr(false)
          setIsDistributorErr(false)
          setDistributorListErr(false)
          setRecordingTypeErr(false)
          setZoomLinkErr(false)
          setRecordingVideoErr(true)
          setErrMessage("Field required")
        }else{
          setRecordingNameErr(false)
          setIsDistributorErr(false)
          setDistributorListErr(false)
          setRecordingTypeErr(false)
          setZoomLinkErr(false)
          setRecordingVideoErr(true)
          setErrMessage("Choose valid file")
        return false
        }
      }
    } 
    
  }
  function isZoomLinkValid(link) {
    const zoomLinkRegex = /^https:\/\/[a-z0-9-]+\.zoom\.us\/j\/\d+\?pwd=[A-Za-z0-9-]+$/;
  
    if (zoomLinkRegex.test(link)) {
      return true
    } else {
      return false
    }
  }
  const recodingVideoCheck = (event)=>{
    const file = event.target.files[0];
    setRecordingVideoErr(false)
  
    setRecordingVideo(event.target.files[0])
  }
  const handleButtonClick = (videoUrl) => {
    const newTab = window.open('', '_blank');
    newTab.document.write(`
      <video controls autoplay width='100%', height='100%'>
        <source src="${videoUrl}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `);
  };
  const handleCloseLink = () =>{
    // setUpcomingRecording('');
    setRecordingVideo('');
    setShow(false)
  
  }
  const handleCloseValue = (id)=>{
    if(id){
      setShowItem(false);
    }
  }
  const handleZoomLinkChange = (event)=>{
    setZoomLink(event);
    setZoomLinkErr(false)
  }
  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section ">
        <div className="head-listing head-listingb">
                            <h3>{id ? "Edit Recording":"Upload New Recording"}</h3>
                        </div>
          <div className='right-section-box'>

            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Recording Name* </label>
                  <input type="text" defaultValue={recordingName} onChange={(e) => setRecordingName(e.target.value)} className='client-input' placeholder='Enter recording name' />
              {recordingNameErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
                <div className='form-group col-lg-12 no-padding'  >
                  <label className=' control-label'>Customer* </label>
                <div className='lable-set'>
            <label style={{marginRight:'15px', fontSize:'14px'}}>
        <input
          type="radio"
          name="distributor-selector"
          id='6'
          value="6"
          checked={isDistributor == "6"}
          onChange={handleRadioChange}
          style={{marginRight:'10px'}}
        />
        Specific Customer
      </label >
      <label style={{marginRight:'15px', fontSize:'14px'}}>
        <input
          type="radio"
          name="distributor-selector"
          id='7'
          value="7"
          checked={isDistributor == "7"}
          onChange={handleRadioChange}
          style={{marginRight:'10px'}}
        />
        All Customer
      </label>
      </div>
      {isDistributorErr ? <div className='linkError'>{errMessage}</div>:""}
      </div>
      {isDistributor == 6 && ( 
        <div className='form-group col-lg-12 no-padding'>
        <label className=' control-label'>
        Customer List*</label>
        <Multiselect options={withoutDulcateDistributorData} selectedValues={_tempdistributor}  displayValue="name"  onSelect={handleChange} onRemove={handleChange}  />
          {distributorList.map((item)=>{
            withoutDulcateDistributorData.map((value)=>{
              if(item == value.id){
                _tempdistributor.push({name:value.name,id:value.id})

            // return (<span>{value?.name} iugytfrutiykguj</span>)


              }
            })
          })
          }
    {distributorListErr ? <div className='linkError'>{errMessage}</div>:""}
    {/* {simpleArr = [...new Set(_tempdistributor)]} */}
  
    {/* <div style={{color:'red'}}>
    {id && simpleArr> 0? simpleArr.map((v, i)=>{
        return (
        <div key={i} style={{marginRight:'10px !important'}}>{v.name + ","} jhgftgycgvhjbkdemo<HighlightOffIcon /></div> 
        )
        }): ''} 
        </div> */}

        
        </div>
      )}
              </div>
            </div>

            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Recording*</label>
                  <select value={recordingType} onChange={(e)=>setRecordingType(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Recording Type</option>
                    <option value="1" >Link</option>
                    <option value="2" >Video</option>
                  </select>
                  {recordingTypeErr ? <div className='linkError'>{errMessage}</div>:""}

                  </div>

                {recordingType == 1&&<div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>Zoom Link*</label>
                  <input type="text" value={zoomLink} onChange={(e) => {handleZoomLinkChange(e.target.value)}} className='client-input' placeholder='https://zoom.us/j/1234567890' />
                  {zoomLinkErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>}
                {recordingType == 2&&
                <div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>Recording Video*</label>
                  {/* <input  type="file" accept=".mov,.mp4" ref={inputRef} onChange={(e)=>recodingVideoCheck(e)} className='client-input' placeholder='Enter link' /> */}
                  <input  type="file"  onChange={(e)=>recodingVideoCheck(e)} className='client-input' placeholder='https://zoom.us/j/1234567890' />
                  {
                    id && show &&  upcomingRecording.length>0&& upcomingRecording !== ''? <div style={{display:'flex',marginTop: "20px"}}><label className='control-label'>Browser link : </label><p  className='view-recording' target="_blank" onClick={()=>handleButtonClick(upcomingRecording)}>{upcomingRecording}</p><HighlightOffIcon style={{color:'blue', marginLeft:'5px', cursor:'pointer'}} onClick={handleCloseLink}/></div>: ""
                    
                  }
                  {recordingVideoErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
                }
                    {id ? <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Status*</label>
                  <select value={statusField} onChange={(e)=>setStatusField(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Status</option>
                    <option value="1" selected={statusField == 1 ? "Selected": ''}>Active</option>
                    <option value="0" selected={statusField == 0 ? "Selected": ''}>Inactive</option>
                  </select>
                  {statusFieldErr ? <div className='linkError'>{errMessage}</div>:""}
                 </div>:''}
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                  
                {id ?  <button type="submit" className='btn btn-primary_d' onClick={updateProfile}>Update
                  </button> :
                  <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                  </button>}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <Modal isOpen={downloaderModal} toggle={DownloaderToggleModal} className="connect-box" centered={true}>
                            <ModalHeader toggle={DownloaderToggleModal}><span className="ml-1 roititle font-weight-bold">Request processing...</span></ModalHeader>
                            <ModalBody>
                            <div className="modal-p">
                                <p className='text-center'>Please wait...</p>
                                <div v-if="loading" className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
      </div>
                            </ModalBody>

                        </Modal>

      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>{id?"Updated":"Created"}</h4>
            <p>Customer Recording has been {id?"Updated":"Created"} successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default UploadRecordingCustomer;
  
